import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import NewPostContainer from './newPost/container';
import R from 'ramda';
import SinglePost from './postTypes/singlePostContainer';
import InfiniteScroll from 'react-infinite-scroll-component';
import LoadingBox from './postTypes/loadingBox';
import FilterHeader from './filterHeader';
import { StyleSheet, css } from 'aphrodite';

const propTypes = {
  selectedLeftNav: PropTypes.string,
  newsfeed: PropTypes.array,
  loadMore: PropTypes.func,
  changeNewsfeedFilter: PropTypes.func,
  hasMore: PropTypes.bool,
  filter: PropTypes.object,
  filterType: PropTypes.string,
};

class Feed extends Component {
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  filterByHashTag = tag => this.props.changeNewsfeedFilter({ value: R.replace('#', '', tag), text: tag }, 'hashtag');

  render() {
    const {
      newsfeed,
      hasMore,
      loadMore,
      filter,
      filterType,
    } = this.props;

    const loaderComponent = ([1, 2, 3].map((_, i) => <LoadingBox key={i}/>));
    const firstPostNotLoaded = false || !R.isEmpty(newsfeed) && newsfeed.slice(0, 1).some(obj => !R.prop('loaded', obj));

    const styles = StyleSheet.create({
      newsfeedContainer: {
        position: 'relative',
        '@media (min-width: 1000px)': {
          ':before': {
            background: '#E0E0E0',
            content: "''",
            display: 'block',
            height: '100%',
            left: '30px',
            position: 'absolute',
            top: '10px',
            width: '2px',
            zIndex: 0,
          },
        },
      },
    });

    return (
      <div className="Grid">
        {
          filterType && filter && filter.value ? (<FilterHeader
            filterType={filterType}
            iconClassName={R.prop('icon', filter)}
            iconColor={R.prop('iconColor', filter)}
            text={filter.text}
          />) : <NewPostContainer />
        }
        <div style={{ width: '100%' }} className={css(styles.newsfeedContainer)}>
          {
            newsfeed.loadingNF && loaderComponent
          }
          <InfiniteScroll
            next={loadMore}
            hasMore={hasMore}
            scrollThreshold={0.6}
            loader={loaderComponent}
            endMessage={
              <p style={{ textAlign: 'center' }}>
                <b>Yay! You have seen it all!</b>
              </p>
            }
          >
            {
              newsfeed.map((post, i) => <SinglePost key={i} {...post} filterByHashTag={this.filterByHashTag} />)
            }
          </InfiniteScroll>
        </div>
      </div>
    );
  }
}

Feed.propTypes = propTypes;

const mapStateToProps = ({ newsfeed }) => ({
  selectedLeftNav: newsfeed.toJS().selectedLeftNav,
  newsfeed: newsfeed.toJS().newsfeed,
  hasMore: newsfeed.toJS().hasMore,
  filterType: newsfeed.toJS().filterType,
  filter: newsfeed.toJS().filter,
});

export default connect(mapStateToProps)(Feed);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/mainFeed/container.jsx